<template>
	<label
		:class="labelClasses"
		tabindex="0"
		@keydown.enter="labelToggle"
		@keydown.space="labelToggle"
	>
		<slot name="header"></slot>

		<span class="form-checkbox-wrapper">
			<span class="form-checkbox">
				<input
					type="checkbox"
					:value="value"
					:checked="checked"
					:name="name"
					:id="id"
					:class="inputClass"
					ref="input"
					@input="$emit('input', $event.target.value, $event.target.checked)"
				>
				<span class="fancy-checkbox">
					<svg-checkmark />
				</span>
			</span>

			<slot></slot>
		</span>
	</label>
</template>
<script>
export default {
	props : {
		value : {
			type : [ Number, String ]
		},
		name : {
			type : String
		},
		labelClass : {
			type : String,
			default () {
				return ''
			}
		},
		inputClass : {
			type : String,
			default () {
				return ''
			}
		},
		id : {
			type : String
		},
		checked : {
			type : Boolean
		}
	},
	computed : {
		labelClasses () {
			let classes = this.labelClass.trim()
			const slots = Object.keys(this.$slots)
			classes += slots.length ? ' form-checkbox-label' : ' form-checkbox-no-label'

			return classes;
		}
	},
	methods : {
		labelToggle () {
			this.$refs.input.click()
		}
	}
}
</script>

<style lang="scss">
.form-checkbox-no-label, .form-checkbox-no-label .form-checkbox-wrapper {
	display: inline-block;
	width: 18px;
	height: 18px;
	line-height: 18px;
}
.form-checkbox {
	position:relative;
	display: inline-block;
	width: 18px;
	height: 18px;
	font: normal normal normal 14px/1 FontAwesome;
	color: white;
	vertical-align: bottom;
	text-align: center;

	/* Hide default HTML checkbox */
	input {
		display: none;

		&:checked + .fancy-checkbox {
			background: #0D82DF;

			&:before {
				background: transparent;
			}
		}

		&:disabled + .fancy-checkbox {
			cursor: default;
		}

		&.error + .fancy-checkbox {
			background: lighten(#ff0000, 30%);
		}
	}

	.fancy-checkbox {
		svg {
			color: #fff;
			width: 12px;
			height: 12px;
		}
	}

	/* The fancy-checkbox */
	span {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #D7E5FF;
		transition: 0.2s;
		border-radius: 3px;
		display: flex;
		align-items: center;
		justify-content: center;

		&:before {
			position: absolute;
			content: "";
			height: 16px;
			width: 16px;
			left: 1px;
			bottom: 1px;
			background-color: white;
			transition: 0.2s;
			font-size: 16px;
			line-height: 18px;
			border-radius: 2px;
		}
	}
}
</style>